export default {
	SupNoDownList: [],
	Total: 0,
	IsLoading: false
};
